import { Trascodifica } from "./trascodifica";

export class VideoImmobile
{
  id: number;
  dataCreazione: Date;
  videoId: string;
  idImmobile: number;
  platform: Trascodifica;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/video-immobile.ts